import React, { useState } from "react";
import { colors } from "../../../../../../../themes/Colors";
import CatalogueListItem from "../catalogue-list-item/CatalogueListItem";

const CatalogueCategory = ({
  item,
  productsArray,
  index,
  selectedIndex,
  setSelectedProduct,
  setSelectedIndex,
  search,
}) => {
  const [categoryProductList, setCategoryProductList] = useState(null);
  const [categoryProductListModal, setCategoryProductListModal] =
    useState(false);
  const [hover, setHover] = useState(false);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        // minHeight: 45,
      }}
    >
      <div
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={() => {
          setSelectedIndex(index === selectedIndex ? null : index);
          setCategoryProductListModal(categoryProductListModal ? false : true);
        }}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: hover ? colors.greenDark : colors.greenLight50,
          minHeight: 45,
        }}
      >
        <div style={{ marginLeft: 10, color: hover ? colors.white : null }}>
          {item.categoryName}
        </div>
        <div style={{ flex: 1 }} />
        <div style={{ marginRight: 10, color: hover ? colors.white : null }}>
          {/* product count */}
        </div>
      </div>
      {categoryProductListModal ? (
        <div
          style={{
            width: "100%",
            minHeight: 40,
            backgroundColor: colors.secondaryDarkBlue,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ minWidth: 40, maxWidth: 40 }}></div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.2,
            }}
          >
            <div style={{ marginLeft: 10 }}> Product Name</div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.2,
            }}
          >
            Category
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.2,
            }}
          >
            Price
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.2,
            }}
          >
            Created By
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.15,
            }}
          >
            Date Created
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.1,
              // display: "flex",
              // justifyContent: "center",
              // alignItems: "center",
            }}
          >
            Status
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: 10,
              color: colors.white,
              flex: 0.15,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            ACTIONS
          </div>
        </div>
      ) : null}
      {categoryProductListModal
        ? productsArray.map((product, index) => {
            return item._id === product.categoryId ? (
              <div
                key={index}
                style={{
                  width: "100%",
                  minHeight: 40,
                  height: 40,
                  maxHeight: 40,
                }}
              >
                <CatalogueListItem
                  productName={product.productName}
                  imageUrl={product.imageId}
                  category={product.category}
                  price={product.price}
                  createdBy={product.createdBy}
                  dateCreated={product.createdOn}
                  onViewClick={() => setSelectedProduct(product)}
                />
              </div>
            ) : null;
          })
        : null}
    </div>
  );
};

export default CatalogueCategory;
